export const version = '2.30.6';
//# sourceMappingURL=version.js.map